import { Fragment, useContext } from 'react';
import QuestionSetContext from 'lecture_pages/services/question-set-context';
import t from 'react-translate';

// redux
import { useSelector } from 'react-redux';
import { getFlatCourseAliases } from 'redux/selectors/course';

import NvPopover from 'shared/components/nv-popover';
import NvIcon from 'shared/components/nv-icon';
import useQuestionSetHelpers from 'quizzes/hooks/use-question-set-helpers';
import CorrectAnswer from './correct-answer';
import ProgressiveFeedback from './progressive-feedback';


type QuizHintProps = {
  isCurrentFeedbackShown: boolean;
  setIsCurrentFeedbackShown: (isCurrentFeedbackShown: boolean) => void;
};

const QuizHint = ({
  isCurrentFeedbackShown,
  setIsCurrentFeedbackShown,
}: QuizHintProps) => {
  const courseAliases = useSelector(getFlatCourseAliases);
  const {
    reveal,
  } = useContext(QuestionSetContext);

  const {
    isEditMode,
    isReviewMode,
    isStatement,
    isLongAnswerQuestion,
  } = useQuestionSetHelpers();

  const showCorrectAnswer = isReviewMode && reveal;

  // No need to show any data regarding hint for statement and long answer
  if (isStatement || isLongAnswerQuestion) {
    return null;
  }

  return (
    <Fragment>
      {isEditMode ? (
        <div className='d-flex align-items-center mb-2 mt-6'>
          <div className='label text-black mr-2'>
            {t.QUIZZES.HINTS_LABEL()}
          </div>
          <NvPopover
            showOnHover
            placement='top'
            content={<div>{t.QUIZZES.HINTS_INFO(courseAliases)}</div>}
          >
            <NvIcon icon='info' size='xs-smallest' className='d-flex text-primary' />
          </NvPopover>
        </div>
      ) : (
        <Fragment>
          {isCurrentFeedbackShown && (
            <div className='label text-black mb-2'>
              {t.QUIZZES.HINT()}
            </div>
          )}
        </Fragment>
      )}
      <div className='bottom-section' aria-live='polite'>
        <ProgressiveFeedback onVisibleChange={setIsCurrentFeedbackShown} />
        {showCorrectAnswer && (
          <CorrectAnswer className='mt-1' />
        )}
      </div>
    </Fragment>
  );
};

export default QuizHint;
